// Copy of the standalone Config Studio screens beyond the campaign wizard (Figma 6566:9267, frames
// 45-72): rule automation, reward creation, audience, history and the Config / History tabs.
export const configStudio = {
  tabs: {
    label: 'Config Studio',
    config: 'Config',
    history: 'History'
  },
  entry: {
    title: 'What would you like to configure?',
    campaign: 'A Campaign',
    rule: 'A Rule Automation',
    reward: 'A Reward',
    audience: 'An Audience',
    noPermission: 'Your role cannot create: {{entities}}.'
  },
  stepOf: 'Step {{step}}/{{total}}',
  next: 'Next',
  finalise: 'Finalise',
  confirm: 'Confirm',
  saveDraft: 'Save as draft',
  saveFailed: 'The save did not go through. Please try again.',
  back: 'Back',
  reviewBack: 'back',
  exit: 'Back to chat',
  remove: 'Remove',
  noLimit: 'No limit',
  never: 'Never',
  none: 'None',
  timezone: 'UTC{{offset}}',
  tenantTimezone: 'UTC{{offset}} (tenant timezone)',
  days: 'Days',
  timeWindow: 'Time window',
  from: 'From',
  to: 'To',
  startTime: 'Start time',
  endTime: 'End time',
  timePlaceholder: 'hh:mm',
  period: {
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year'
  },
  periodTitle: {
    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year'
  },
  result: {
    draft: 'Draft saved',
    confirmed: '{{entity}} created',
    pending: 'Submitted for approval',
    viewRequest: 'View approval request',
    view: 'View {{entity}}',
    another: 'Create another'
  },
  errors: {
    positive: '{{field}} must be a whole number above 0.',
    required: '{{field}} is required.',
    timeOrder: 'The end time must be after the start time.',
    dateOrder: 'The end date must be after the start date.',
    daysRequired: 'Pick at least one day.'
  },
  rule: {
    title: 'Let’s setup your Rule',
    entity: 'Rule',
    trigger: {
      question: 'What should trigger this rule?',
      transaction: 'Make a Transaction',
      loyalty: 'Earn or Redeem Loyalty Points',
      milestone: 'Join or Complete a Campaign',
      reward: 'Earn or Redeem Rewards',
      customer: 'A Customer Detail Changes',
      others: 'Something Else (Custom Action)'
    },
    details: {
      transaction: 'What kind of Transaction fires this rule?',
      loyalty: 'Which Loyalty Program’s points fire this rule?',
      milestone: 'What Campaign Activity fires this rule?',
      reward: 'What Reward Activity fires this rule?',
      customer: 'Which customer change fires this rule?',
      others: 'Which Custom Action fires this rule?',
      amount: 'The transaction must be at least',
      amountHint: 'Positive or negative numbers, max 2 decimal places',
      type: 'The transaction must be a',
      typeUnit: 'type',
      properties: 'The transaction must have properties:',
      narrow: 'Should the trigger be narrowed further?',
      merchants: 'Only count transactions from these merchants',
      selectMerchants: 'Select merchants',
      merchantsUnsupported: 'Merchant narrowing is not available yet.',
      firstOnly: 'Only count the first qualifying transaction per customer',
      loyaltyLead: 'Users earn points in',
      milestoneLead: 'Users',
      rewardLead: 'Users',
      customerLead: 'The customer',
      othersLead: 'The custom action',
      customerEvent: {
        customer_signed_up: 'Signs up',
        customer_signed_in: 'Signs in',
        customer_profile_updated: 'Updates their profile'
      },
      transactionEmpty: 'Set at least one transaction condition.',
      amountInvalid: 'The amount takes up to 2 decimal places.',
      selectCampaign: 'Select a campaign.',
      selectReward: 'Select a reward.',
      selectLoyalty: 'Select a loyalty program.',
      selectAction: 'Select a custom action.'
    },
    outcome: {
      question: 'What should happen when this rule is triggered?',
      stamp: 'Issue Bonus Stamp',
      game: 'Issue Game Tries',
      reward: 'Issue a Reward',
      points: 'Award Points',
      audience: 'Add user to an Audience',
      customer: 'Update Customer Details',
      push: 'Push Notification'
    },
    outcomeDetails: {
      stamp: 'Issue Bonus Stamp — select the campaign and quantity',
      game: 'Issue Game Tries — select the campaign and quantity',
      reward: 'Issue a Reward — select the reward',
      points: 'How many points should users be awarded?',
      audience: 'Which Custom Audience should the user be added to?',
      customer: 'Which customer details should be updated?',
      push: 'Do you want to set any media tags or Custom Payload?',
      selectCampaign: 'Select Campaign:',
      selectCampaignButton: 'Select Campaign',
      stamps: 'Number of stamps to award:',
      tries: 'Number of game tries to award:',
      selectReward: 'Selected Reward:',
      selectRewardButton: 'Select Reward',
      award: 'Award',
      pointsFrom: 'points from',
      customAudience: 'Custom Audience:',
      customAudiencePlaceholder: 'Select Custom Audience',
      propertyKey: 'Property (JSON key)',
      propertyValue: 'value',
      addMore: 'Add More',
      mediaTag: 'Include this Media tag in the notification:',
      customPayload: 'Custom Payload',
      payloadKey: 'key',
      payloadValue: 'value',
      addCustomField: 'Add Custom field',
      campaignRequired: 'Select a campaign.',
      quantityRequired: 'The quantity must be a whole number above 0.',
      rewardRequired: 'Select a reward.',
      loyaltyRequired: 'Select a loyalty program.',
      pointsRequired: 'The points must be a whole number above 0.',
      audienceRequired: 'Select a custom audience.',
      propertiesRequired: 'Add at least one property with a key and a value.'
    },
    schedule: {
      question: 'When should this rule run?',
      start: 'Start this Rule from',
      end: 'End this rule on',
      endPlaceholder: 'Select date and time',
      specific: 'Rule will only trigger on specific days / times',
      limits: 'Any Other Limits?',
      total: 'Rule can trigger maximum',
      totalUnit: 'times',
      perPerson: 'Rule can trigger maximum',
      perPersonUnit: 'times per person',
      rate: 'Rate limit this rule to',
      rateUnit: 'times per',
      userRate: 'Rate limit users to',
      userRateUnit: 'times per person per',
      startRequired: 'Pick the rule’s start date.',
      endRequired: 'Pick the rule’s end date.'
    },
    review: {
      ready: 'We’re Ready to Create your Rule Automation!',
      question: 'Let’s make sure we got everything right…',
      name: 'Rule Name',
      namePlaceholder: 'Name this rule',
      nameRequired: 'Name the rule before you save it.',
      start: 'Rule Start',
      end: 'Rule End',
      trigger: 'Trigger',
      outcome: 'Rule Outcome',
      window: 'Specific Days / Times',
      limits: 'Limits',
      amount: 'Amount >= {{value}}',
      type: 'Type: {{value}}',
      property: 'Transaction property: {{key}} {{operator}} {{value}}',
      equals: 'EQUALS',
      notEquals: 'NOT EQUALS',
      firstOnly: 'First qualifying transaction per customer only',
      stampOutcome: 'Issue Bonus Stamp: {{value}} stamps in {{name}} (id: {{id}})',
      gameOutcome: 'Issue Game Tries: {{value}} tries in {{name}} (id: {{id}})',
      rewardOutcome: 'Issue a Reward: {{name}} (id: {{id}})',
      pointsOutcome: 'Award Points: {{value}} points from {{name}}',
      audienceOutcome: 'Add user to an Audience: {{name}}',
      customerOutcome: 'Update Customer Details: {{value}}',
      pushOutcome: 'Push Notification',
      maxTriggers: 'Max triggers: {{value}}',
      maxPerPerson: 'Max per person: {{value}}',
      ruleRate: 'Rule rate: {{value}} per {{period}}',
      userRate: 'User rate: {{value}} per person per {{period}}',
      anyDay: 'Any day and time',
      dateTime: '{{value}} (UTC{{offset}})'
    }
  },
  reward: {
    title: 'Let’s Setup your Reward',
    entity: 'Reward',
    type: {
      question: 'What type of Reward would you like to create?',
      text: 'A text based voucher code',
      qr: 'A QR Code to be scanned',
      barcode: 'A Barcode to be scanned',
      url: 'An external URL',
      api: 'Redeemed directly through an external API',
      pin: 'Redeemed by the merchant entering their PIN code'
    },
    typeName: {
      text: 'Text based voucher code',
      qr: 'QR Code to be scanned',
      barcode: 'Barcode to be scanned',
      url: 'External URL',
      api: 'External API redemption',
      pin: 'Merchant PIN redemption'
    },
    source: {
      textQuestion: 'Where should the codes for this text based voucher code come from?',
      qrQuestion: 'Where should the QR Code values come from?',
      barcodeQuestion: 'Where should the Barcode values come from?',
      label: 'Code Source (select one)',
      fixed: 'A fixed Code',
      fixedValue: 'A fixed value',
      generate: 'Generate it for me',
      csv: 'Upload a CSV file with the codes',
      inventory: 'Inventory',
      textValue: 'Voucher Code',
      qrValue: 'QR Code value',
      barcodeValue: 'Barcode value',
      required: '(required)',
      selectInventory: 'Select Inventory',
      csvHint: 'The CSV file is uploaded on the Reward page after the draft is saved.',
      generateHint: 'A unique code is generated for every issued reward.',
      preview: 'Preview',
      qrPreview: 'Reward QR Code',
      barcodePreview: 'Reward Barcode',
      previewBody:
        'This is how the code will be rendered in the customer’s wallet. The encoded value is shown below.',
      errorCorrection: 'Error correction level',
      symbology: 'Barcode symbology',
      unsupported: 'Saved with the reward once the backend supports it.',
      ecc: {
        L: 'L — 7% recovery',
        M: 'M — 15% recovery (recommended)',
        Q: 'Q — 25% recovery',
        H: 'H — 30% recovery'
      },
      symbologies: {
        code128: 'Code 128 (recommended)',
        ean13: 'EAN-13',
        code39: 'Code 39'
      },
      valueRequired: 'Enter the code value.',
      inventoryRequired: 'Select an inventory.'
    },
    url: {
      question: 'Will the Reward use the same URL for every customer?',
      label: 'URL Type',
      static: 'Static URL for all users',
      unique: 'Unique URL for each user',
      value: 'URL (required)',
      uniqueUnsupported: 'Unique URLs per user are not available yet.',
      required: 'Enter a URL starting with http:// or https://.'
    },
    api: {
      question: 'How should the external API redemption be configured?',
      select: 'Select API (required)',
      selectPlaceholder: 'Select API',
      unique: 'Does API require a unique code per user?',
      no: 'No',
      noHint: 'The API will be called without a per-user code.',
      csv: 'Yes, I will upload a CSV',
      inventory: 'Yes, from an Inventory',
      random: 'Yes, a random value',
      mapping: 'API parameter mapping',
      key: 'key',
      value: 'value',
      prefix: 'prefix',
      suffix: 'suffix',
      mappingNote:
        'Values in {{braces}} are substituted at redemption time from the customer, reward and merchant records.',
      addParam: 'Add parameter',
      required: 'Select an API.'
    },
    pin: {
      question: 'Which merchant will redeem this Reward using their PIN?',
      select: 'Select Merchant (required)',
      placeholder: 'Select Merchant',
      hint: 'Only one merchant can be selected.',
      required: 'Select a merchant.'
    },
    visibility: {
      question: 'How should this reward be made available?',
      public: 'Public',
      publicHint: 'Visible to all eligible users on your Rewards Catalogue',
      private: 'Private',
      privateHint: 'Not visible on the catalogue, but usable for Campaigns & Rules',
      system: 'System',
      systemHint: 'A hidden reward not visible anywhere, and only used with Rules',
      availability: 'Reward Availability',
      start: 'Start Date',
      hasEnd: 'Reward has an end date',
      end: 'End Date',
      certainDays: 'Reward is only available on certain days',
      startRequired: 'Pick the reward’s start date.',
      endRequired: 'Pick the reward’s end date.'
    },
    expiry: {
      question: 'When will this reward expire?',
      never: 'Never',
      neverHint: 'The reward will not expire.',
      fixed: 'On a fixed date',
      fixedPlaceholder: 'Select date and time',
      days: 'Days after issuance',
      daysPlaceholder: 'Enter days',
      daysUnit: 'days after issuance',
      fixedRequired: 'Pick the expiry date.',
      daysRequired: 'The days after issuance must be a whole number above 0.'
    },
    limits: {
      question: 'Any Limits?',
      issuance: 'Limit the reward issuance to',
      lifetime: 'Each user is limited to a maximum of',
      lifetimeUnit: 'issuances in a lifetime',
      perUser: 'Each user can only be issued up to',
      redemption: 'Rate cap redemptions to',
      per: 'per',
      cost: 'Reward Cost price',
      currency: 'Cost price currency',
      selling: 'Reward selling price',
      sell: 'Sell this reward for',
      points: 'points',
      loyalty: 'Loyalty program',
      tiers: 'Tier (multi-select)',
      costInvalid: 'The cost price takes up to 2 decimal places.',
      loyaltyRequired: 'Select the selling price’s loyalty program.'
    },
    review: {
      ready: 'We’re Ready to Create your Reward!',
      question: 'Let’s make sure we got everything right…',
      name: 'Reward Name',
      namePlaceholder: 'Name this reward',
      nameRequired: 'Name the reward before you save it.',
      type: 'Reward Type',
      availability: 'Availability Date',
      start: 'Start: {{value}}',
      end: 'End: {{value}}',
      noEnd: 'End: None',
      redemption: 'Redemption Type',
      expiry: 'Expiry',
      cost: 'Cost Price',
      selling: 'Selling Price',
      visibility: 'Visibility',
      limits: 'Limits',
      days: 'Days: {{value}}',
      fixedSource: 'Fixed code · {{value}}',
      generateSource: 'Generated codes',
      csvSource: 'Codes from a CSV upload',
      inventorySource: 'Inventory · Source: {{value}}',
      staticUrl: 'Static URL · {{value}}',
      uniqueUrl: 'Unique URL per user',
      apiSource: 'External API · {{value}}',
      pinSource: 'Merchant PIN · {{value}}',
      neverExpires: 'Never',
      fixedExpiry: 'On {{value}}',
      daysExpiry: '{{value}} days after issuance',
      sellingValue: '{{points}} points ({{name}}{{tiers}})',
      notForSale: 'Not for sale',
      publicValue: 'Public — visible to eligible users in Rewards Catalogue',
      privateValue: 'Private — usable for Campaigns & Rules',
      systemValue: 'System — only used with Rules',
      issuance: 'Issuance: {{value}}/{{period}}',
      lifetime: 'Lifetime: {{value}}/user',
      perUser: 'Per-user issuance: {{value}}/{{period}}',
      redemptionCap: 'Redemption cap: {{value}}/{{period}}'
    }
  },
  audience: {
    title: 'Create Audience',
    entity: 'Audience',
    name: 'Audience name:',
    nameRequired: 'Name the audience.',
    list: 'Audience list',
    question: 'Select filters to auto-generate an audience list',
    hint: 'Pick one or more attributes. Custom lets you match on any key and value held against the customer.',
    groups: {
      demographics: 'Demographics',
      engagement: 'Engagement',
      custom: 'Custom'
    },
    attributes: {
      age: 'Age',
      birthmonth: 'Birth Month',
      gender: 'Gender',
      race: 'Ethnicity',
      location: 'Location',
      earned_badges: 'Badge',
      campaign_enrolment: 'Campaign',
      leaderboard_position: 'Leaderboard',
      loyalty_points_balance: 'Loyalty Points',
      loyalty_tier: 'Loyalty Tier',
      account_confirmed_at: 'Member Since',
      earned_rewards: 'Reward',
      custom: 'Custom'
    },
    attributeUnsupported: 'Set this filter’s values in the Audience builder after saving.',
    locked: 'Locked filter',
    lockedHint: 'Set by Orbit from the Layer 2 signal; it cannot be changed here.',
    string: 'String',
    keyValue: 'Enter key name and value details',
    key: 'Key name',
    value: 'Value',
    operatorLabel: '{{key}} operator',
    operators: {
      eq: 'equals',
      neq: 'does not equal to',
      in: 'in',
      not_in: 'not in'
    },
    addCustom: 'Add custom properties',
    count_one: '{{count}} custom property · matched with AND',
    count_other: '{{count}} custom properties · matched with AND',
    removeProperty: 'Remove property',
    create: 'Create audience',
    cancel: 'Cancel',
    filterRequired: 'Pick at least one filter with a key and a value.',
    commaNotAllowed: 'Separate in / not in values with a comma only, without empty items.'
  },
  history: {
    title: 'History',
    subtitle: 'Everything configured here, newest first.',
    search: 'Search by name or ID',
    newConfiguration: 'New configuration',
    types: {
      all: 'All types',
      campaign: 'Campaigns',
      rule: 'Rules',
      reward: 'Rewards',
      audience: 'Audiences'
    },
    type: {
      campaign: 'Campaign',
      rule: 'Rule',
      reward: 'Reward',
      audience: 'Audience'
    },
    status: {
      draft: 'Draft',
      live: 'Live',
      in_review: 'In review',
      ended: 'Ended'
    },
    columns: {
      name: 'Name',
      type: 'Type',
      status: 'Status',
      createdBy: 'Created by',
      updated: 'Last updated',
      actions: 'Actions'
    },
    view: 'View {{name}}',
    duplicate: 'Duplicate {{name}}',
    showing: 'Showing {{shown}} of {{total}}',
    empty: 'Nothing configured matches your search.',
    previous: 'Previous page',
    nextPage: 'Next page',
    page: 'Page {{page}}'
  }
};
